var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.25759b29cd6965982ed1e66bb75ea4bf.svg#h';
                    var viewUrl = 'sprites.25759b29cd6965982ed1e66bb75ea4bf.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };